import { Header, Markdown } from "@prmf/site-components";
import { routes, t } from "@prmf/site-router";
import { NavLink, useParams } from "@remix-run/react";
import { clsx } from "clsx";
import { useRef } from "react";

const data = Object.entries(
  import.meta.glob<true, string, string>("../assets/terms/*.md", {
    import: "default",
    query: "?raw",
    eager: true,
  }),
).reduce<Record<string, string>>((p, [k, v]) => {
  const key = k.replace("../assets/terms/", "").replace(".md", "");
  p[key] = v;
  return p;
}, {});

const Terms: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const section = useParams().section || "supply-to-customers";
  return (
    <div>
      <Header title={t(routes.terms, "title")} image={t(routes.terms, "image")}>
        <p>
          Welcome to our website. If you continue to browse and use this website
          you are agreeing to comply with and be bound by the following terms
          and conditions of use, which together with our privacy policy govern
          Paula Rosa Manhattan's relationship with you in relation to this
          website.
        </p>
      </Header>
      <div
        className={clsx(
          "container",
          "py-10 pb-20",
          "max-md:space-y-10",
          "md:grid md:grid-cols-5 md:place-items-start md:divide-x md:pt-20",
        )}
      >
        <nav className="grid w-full gap-2 text-sm md:sticky md:top-10">
          {[
            "supply-to-customers",
            "purchase-of-goods",
            "purchase-of-goods-services",
            "gdpr",
            "whistleblower",
            "download-policies",
          ].map((k) => (
            <NavLink
              key={k}
              to={`/terms/${k}`}
              onClick={() => ref.current?.scrollIntoView()}
              preventScrollReset
              className="[&.active]:font-bold"
            >
              {k}
            </NavLink>
          ))}
        </nav>
        <section
          ref={ref}
          className={clsx(
            "col-span-4 space-y-4 text-sm leading-loose md:pl-10",
            "[&_h2]:text-lg",
            "[&_h2]:font-bold",
            "[&_h3]:font-bold",
            "[&_h4]:font-bold",
            "[&_h5]:font-bold",
          )}
        >
          <Markdown
            components={{ h1: "h2", h2: "h3", h3: "h4", h4: "h5" }}
            children={String(data[section])}
          />
        </section>
      </div>
    </div>
  );
};

export default Terms;
